module.exports = __webpack_public_path__ + "img/diagonal-top-right.7669311b.png";